import { render, staticRenderFns } from "./m-menu-chip.vue?vue&type=template&id=0ff5082a&scoped=true&"
import script from "./m-menu-chip.vue?vue&type=script&lang=js&"
export * from "./m-menu-chip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff5082a",
  null
  
)

export default component.exports